import { useStores } from "../../stores/root-store";
import { observer } from "mobx-react";
import _ from "lodash";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "react-bootstrap";
import { IModal } from "../../stores";
import { useCallback, useEffect } from "react";
import { ShowAlert } from "../../utils/functions";
import { IProductAddOn } from "../../stores/products";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";

const ProductAddOnForm = observer(({ show, setShowModal }: IModal) => {
  const { productStore } = useStores();
  const { editProduct, addOns, fetchAddOns, saveProductAddOns } = productStore;

  const isEditRequest = editProduct != null && editProduct.productId > 0;

  useEffect(() => {
    if (!addOns?.length && editProduct?.productId)
      fetchAddOns(editProduct?.productId);
  }, [addOns, editProduct?.productId]);

  const handleAddonCheck = (addOn: IProductAddOn, checked: boolean) => {
    addOn.isSelected = checked;
  };

  const submitCallback = useCallback((res: boolean) => {
    if (res) {
      setShowModal(false);
      ShowAlert.Success("Product add-ons updated successfully.");
    } else {
      ShowAlert.Error("Request failed. Please try again.");
    }
  }, []);

  const handleFormSubmit = () => {
    const isFormValid = editProduct != null;
    if (!isFormValid) {
      ShowAlert.Error("One or more field value missing.");
      return;
    }

    var selectedAddOnIds = _.map(
      addOns.filter((p) => p.isSelected),
      (a) => {
        return a.addOnId;
      }
    );
    saveProductAddOns(editProduct.productId, selectedAddOnIds, submitCallback);
  };

  return (
    <Modal show={show} onHide={() => setShowModal(false)} className="modal-lg">
      <ModalHeader closeButton>
        <Modal.Title>
          <h5>{isEditRequest ? "Update" : "Add"} Product Add-Ons</h5>
        </Modal.Title>
      </ModalHeader>
      <ModalBody>
        <form>
          <div className="">
            <h3>
              <span className="badge text-bg-dark">
                {editProduct?.productName}
              </span>
            </h3>
            <h6>Choose Product Categories</h6>
            <div
              className="d-flex flex-wrap"
              role="group"
              aria-label="Basic checkbox toggle button group"
            >
              {addOns?.map((addOn) => (
                <div className="m-2 flex-fill">
                  <input
                    type="checkbox"
                    className="btn-check"
                    id={`cb${addOn.addOnId}`}
                    autoComplete="off"
                    checked={addOn.isSelected}
                    onChange={(e) => handleAddonCheck(addOn, e.target.checked)}
                  />
                  <label
                    className="btn btn-outline-success shadow-lg position-relative flex-fill"
                    htmlFor={`cb${addOn.addOnId}`}
                  >
                    {addOn.addOnName}
                    <span
                      onMouseOut={() => {
                        addOn.showOptions = false;
                      }}
                      onMouseOver={() => {
                        addOn.showOptions = true;
                      }}
                      className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-info"
                    >
                      i
                    </span>
                  </label>
                  {addOn.showOptions && (
                    <div className="position-absolute" style={{ zIndex: 999 }}>
                      <div className="card">
                        <div className="card-body">
                          <ul className="list-group list-group-flush">
                            {addOn.addOnOptions?.map((opt) => (
                              <li className="list-group-item">
                                {opt.addOnOption.addOnOptionName}
                              </li>
                            ))}
                          </ul>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              ))}
              {!addOns?.length && <div>No add-ons available.</div>}
            </div>
          </div>
        </form>
      </ModalBody>
      {addOns?.length > 0 && (
        <ModalFooter>
          <button
            className="btn btn-default flex-fill"
            onClick={handleFormSubmit}
          >
            <FontAwesomeIcon icon={faEdit} className="me-2" />
            <span>Update Add-Ons</span>
          </button>
        </ModalFooter>
      )}
    </Modal>
  );
});

export default ProductAddOnForm;
